module.exports = __webpack_public_path__ + "img/whatsapp-notification.cdaab878.svg";